import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from "@sundae/ui-toolkit";
import cx from "classnames";
export const ForumInput = ({ wrapperProps = {}, inputProps = {}, forumMeta }) => {
    const mergedInputProps = {
        ...inputProps,
        className: cx(inputProps.className),
        value: inputProps.value,
        onChange: (e) => {
            if (e.target.value.indexOf(forumMeta.prefix) !== 0) {
                inputProps.onChange({
                    target: { value: forumMeta.prefix },
                });
                return;
            }
            const mutatedValue = e.target.value.replace(forumMeta.prefix, "");
            const resolvedValue = `${forumMeta.prefix}${mutatedValue}`;
            inputProps.onChange({ target: { value: resolvedValue } });
        },
    };
    return (_jsx("div", { ...wrapperProps, children: _jsx(Input, { ...mergedInputProps }) }));
};
//# sourceMappingURL=ForumInput.js.map